
<template>
	<div class="box">
	  <div class="boxTitle">欧盟贸易额专区</div>
    <div class="miniTitle">
      <span>2021-2023年进出口贸易额</span>
      <span>2023年欧盟国家贸易额</span>
    </div>
	  <div class="echart">
	    <div id="echart11" style="height:400px;width: 50%;"></div>
      <div id="echart22" style="height:400px;width: 50%;"></div>
	  </div>
	</div>
</template>

<script>
  import * as echarts from 'echarts';
	export default {
		name: "Four",
		data() {
      return {
        Chart:null,
        option:null,

        Chart2:null,
        option2:null,
      }
		},
    mounted() {
      this.datainfo();
      this.datainfo2();
    },
    methods:{
      datainfo() {
        this.Chart = this.$echarts.init(document.getElementById('echart11'));
        this.option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['2021', '2022', '2023'],
               axisLine: {
                  lineStyle: {
                      color: '#fff'
                  }
                },
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine:{
                show:false
              },
              axisLine: {
                  lineStyle: {
                      color: '#fff' // 设置 y 轴颜色为蓝色
                  }
              },
            }
          ],
          series: [
             {
              name: '进口',
              type: 'bar',
              emphasis: {
                focus: 'series'
              },
              data: [150, 332, 250],
              itemStyle: {  // 使用方法二的写法
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#0076F5'},
                      {offset:0.5, color:'#00A1C2'},
                      {offset:1,color:'#00CF88'},
                    ]
                   )
                },
              },
            },
            {
              name: '出口',
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series'
              },
              data: [120, 320, 101],
              itemStyle: {
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#F6C40D'},
                      {offset:0.5, color:'#7B9D83'},
                      {offset:1,color:'#0376F6'},
                    ]
                   )
                },
              },
            },
          ]
        };

        this.Chart.setOption(this.option);
      },

      datainfo2() {
        this.Chart2 = this.$echarts.init(document.getElementById('echart22'));
        this.option2 = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              axisLine: {
                   lineStyle: {
                       color: '#fff'
                   }
               },
              type: 'category',
              data: ['意大利', '新西兰', '法国'],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine:{
                show:false
              },
              axisLine: {
                  lineStyle: {
                      color: '#fff' // 设置 y 轴颜色为蓝色
                  }
              },
            }
          ],
          series: [
             {
              name: '进口',
              type: 'bar',
              emphasis: {
                focus: 'series'
              },
              data: [500, 100, 420],
              itemStyle: {  // 使用方法二的写法
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#0076F5'},
                      {offset:0.5, color:'#00A1C2'},
                      {offset:1,color:'#00CF88'},
                    ]
                   )
                },
              },
            },
            {
              name: '出口',
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series'
              },
              itemStyle: {  // 使用方法二的写法
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#F6C40D'},
                      {offset:0.5, color:'#7B9D83'},
                      {offset:1,color:'#0376F6'},
                    ]
                   )
                }
              },
              data: [302, 450, 100]
            },
          ]
        };

        this.Chart2.setOption(this.option2);
      }
    }
	}

</script>

<style>
  .echart{
    display:flex;
    justify-content:center;
  }
  .box{
    position:relative;
  }
  .miniTitle{
    font-size:15px;
    color:#fff;
    display:flex;
    width:100%;
    position:absolute;
    top:65px;
  }
  .miniTitle span{
    width:50%;
    padding-left:15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/right/seven.vue